/**
 * Le entrega al navegador un archivo para guardar, con su nombre.
 *
 * El enlace temporal es la unica forma de elegir el nombre del archivo desde
 * la pagina; la URL del blob se libera despues, cuando el navegador ya la tomo.
 */
export function guardarArchivo(archivo: Blob, nombre: string): void {
  const url = URL.createObjectURL(archivo);
  const enlace = document.createElement('a');
  enlace.href = url;
  enlace.download = nombre;
  document.body.append(enlace);
  enlace.click();
  enlace.remove();
  window.setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 1000);
}
